import { FormattedMessage } from 'react-intl';
import { Schema } from 'src/utils/form';

export default Schema.object({
  colaboradores: Schema.string().label(''),
  areas: Schema.string().label(''),
  considerarAreasSubordinadas: Schema.string().label(''),
  dataCopia: Schema.string().label(<FormattedMessage id="labelDataCopia" />),
  numeroCopia: Schema.string().label(
    <FormattedMessage id="labelNumeroCopia" />
  ),
  codigoVersao: Schema.string().label(
    <FormattedMessage id="labelCodigoVersao" />
  ),
});
